export default {
  weekdays: {
    D: 'D',
    L: 'L',
    Ma: 'M',
    Me: 'M',
    J: 'J',
    V: 'V',
    S: 'S',
  },
  monthsAbbr: {
    JANV: 'JANV.',
    FEVR: 'FÉVR.',
    MARS: 'MARS',
    AVR: 'AVR.',
    MAI: 'MAI',
    JUIN: 'JUIN',
    JUIL: 'JUIL.',
    AOUT: 'AOÛT',
    SEPT: 'SEPT.',
    OCT: 'OCT.',
    NOV: 'NOV.',
    DEC: 'DÉC.',
  },
  monthNames: {
    janvier: 'janvier',
    fevrier: 'février',
    mars: 'mars',
    avril: 'avril',
    mai: 'mai',
    juin: 'juin',
    juillet: 'juillet',
    aout: 'août',
    septembre: 'septembre',
    octobre: 'octobre',
    novembre: 'novembre',
    decembre: 'décembre',
  },
  selectYear: "Sélectionner l'année",
}
